import {
  EmagazineArticleLayout,
  PromotionsArticleLayout,
  PromotionsArticleMobileLayout,
  EmagazineArticleMobileLayout,
  IArticle,
  IRelatedProduct,
} from './layout';

export { EmagazineArticleLayout, PromotionsArticleLayout, PromotionsArticleMobileLayout, EmagazineArticleMobileLayout };
export type { IArticle, IRelatedProduct };
